// extracted by mini-css-extract-plugin
export default {"body":"main-input_body__bH9V6","input":"main-input_input__6rlpk","label":"main-input_label__q2AOA"};